import { createFileRoute, redirect } from '@tanstack/react-router'

// The tools section has one tool today; send its bare path to the screener.
export const Route = createFileRoute('/_authenticated/tools/')({
  beforeLoad: () => {
    throw redirect({ to: '/tools/bankruptcy-screener' })
  },
})
